import { h, Fragment, Component } from "preact";

export const CustomSwatchFacet = ({filter, values, facets, facetSelected, swatches_list, setFacetSelected, initialFilterArrayofObjects}) => {
  
  //Initialize empty object
  let isActive = {};
  let isStillAvailable = [];
  let automaticSelect = [];

  //Remove spaces from swatch color if they exist, and replace w/ dashes
  let currentColor = values.label.replace(/\s+/g, '-');

  //Grab data from latest useState Facets
  facets.map((field) => {
    if(field.field == filter.field) {
      //Loop through, check any that are active and match the current Facet Field name
      if(field.facet_active == 1) {
        field.values.map((values) => {
          if(values.active == true) {
            //If something is active, add to empty object
            isActive[values.value] = values.active;
          }
        });
      }

      //Add all available facets from our latest state to our empty array
      field.values.map((values) => {
        isStillAvailable.push(values.value);
      });
    }

    //If a field only has 1 available option left
    //Select it automatically
    if(field.values.length == 1){
      //Loop through the available value
      field.values.map((values) => {
        let findThis = "";

        //Loop through initial filter array
        initialFilterArrayofObjects.map((initialFilter) => {
          //Make sure it doesnt equal any of those, we don't want to mess with the original filters
          if(initialFilter.filterValue != values.label) {

            if(document.querySelector(`[data-ss-value-label='${values.label}']`)) {
              //Find the value in the DOM. Grab its Field via attributes
              findThis = document.querySelector(`[data-ss-value-label='${values.label}']`).dataset.ssField;
            }

            if(findThis) {
              //Add the value to automatic select array
              if(automaticSelect.filter(existingFilter => existingFilter.filterValue == values.value).length <= 0){
                //This will be added to updateSelectedFacets later
                automaticSelect = [
                  ...automaticSelect,
                  {
                    filterField: findThis,
                    filterValue: values.label
                  }
                ]
              }
            }
          }
        });
      });
    }
  });

  //Turn empty object into array of objects. Easier to .map()
  let isActiveArray = Object.entries(isActive);

  const onClickColorFacet = function(event){
    //Only populate this function if the current value is available to click
    //Otherwise, will cause Searchspring API errors, and will allow customer to filter to zero products
    if(isStillAvailable.includes(values.label)) {
      let thisElement = event.target;
      let thisParent = thisElement.parentNode;
      let thisParentField = thisParent.parentNode.dataset.ssField;
      if(swatches_list[currentColor] !== undefined) {
        //Prevent Console error if color hex is empty
        thisElement.style.backgroundColor = swatches_list[currentColor].hexValue;
      }

      //OnClick, see if this filter is already selected or not
      if (facetSelected.filter(facet => facet.filterValue == values.label).length > 0) {
        //Remove filter from array if already selected
        facetSelected.map((value) => {
          if(value.filterValue == values.label) {
            setFacetSelected(facetSelected.filter(value => value.filterValue != values.label));
          }
        });
      }
      else {
        //Create an empty array to push filter to
        let filteredArray = [];

        //Filter out any other fields that are selected in this same category
        //Push to new array
        filteredArray = facetSelected.filter(function(value) {
          return value.filterField != filter.field;
        });

        //Add new selection to search query API params, w/ any filtered out selections in same category
        const updateSelectedFacets = [
          ...filteredArray,
          ...automaticSelect,
          {
            filterField: thisParentField,
            filterValue: values.label
          }
        ];

        // Update the state to the updatedUsers
        setFacetSelected(updateSelectedFacets);
      }
    }
  }

  return (
    <div className={`facet-state__facets__swatch-wrapper 
      ${isActiveArray.filter(color => color[0] == values.label).length > 0 ? "active--true" : ""}
      ${!isStillAvailable.includes(values.label) ? "swatch--is-turned-off" : ""}
      ${automaticSelect.filter(filter => filter.filterValue == values.label).length > 0 ? "only-one-left" : ""}
    `
    }>
      <span
        className={`facet-state__facets__value--swatch text-body 
          ${swatches_list[currentColor] !== undefined ? swatches_list[currentColor].label : ""}
        `}
        data-ss-field={filter.field}
        data-ss-value-label={values.label}
        onClick={(event) => {
          onClickColorFacet(event);
        }}
        >
      </span>
      <span className="facet-state__facets__value--swatch-label text-body">{values.label}</span>
    </div>
  )
}